import { Link } from '@unhead/schema'
import type { RouteParams, LocationQuery } from 'vue-router'

export const useCanonicalHead = async ({
    query,
    params,
    routeName
}: {
    params?: RouteParams
    query?: LocationQuery
    routeName?: string
}): Promise<void> => {
    const route = useRoute()
    const config = useRuntimeConfig()
    
        const link: Link = {
            rel: 'canonical',
        }

        if (!routeName) {
             link.href = `${config.public.publicPath}${useNamedRoutes({
                name: route.name,
                params: {
                    id: route.params.id,
                    ...params,
                },
                query: {
                    ...query,
                },
            })}`
        } else {
            link.href = `${config.public.publicPath}${routeName}`
        }

        useHead({
            link: [link],
        })

}
